export const STORAGE_SHIPPING_V2_SOLICITACAO = "meritocracia:shippingV2:solicitacaoId";
export const STORAGE_SHIPPING_V2_YEAR = "meritocracia:shippingV2:selectedYear";
